/**
 * Home Routes
 */

import { createRoute, redirect } from '@tanstack/react-router';
import React from 'react';
import { authLayoutRoute } from '../rootRoute';

// The Assistant page is the home landing for all users (replaces the old
// Home page). It is intentionally ungated — every authenticated user lands
// here; admin-only widgets (users, subscription) degrade gracefully in-widget.
const Assistant = React.lazy(() => import('../../pages/Assistant/Assistant'));

/**
 * Index redirect - /bbweb → /bbweb/home
 */
export const bbwebIndexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/bbweb/home' });
  },
});

/**
 * Home page — the Assistant.
 */
export const homeRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/home',
  component: Assistant,
});

export const homeRoutes = [bbwebIndexRoute, homeRoute];
